module.exports = __webpack_public_path__ + "static/alex-riley-logo-round-6e74d57c2d95005b401e989e6de45e06.png";